export default __webpack_public_path__ + "static/media/swordsIcon.6e7faeaa.png";